export default "__VITE_ASSET__Cjb7PyxZ__"